// Service Imports
import { Toastr } from "../../revvComponents";
import {
  startDataSourceSync,
  fetchAllFormFields,
  fetchFieldMapping,
  getSFObjectSchema,
  fetchDSObjects,
  saveFieldMapping,
  deleteFieldMapping,
  createTriggerService,
  updateTriggerService,
  getTriggerDetailsService,
  getTriggerPackageService,
} from "./fieldsSettingService";

// Store Import
import store from "../../store";

// Internal Imports
import { GlobalUtils } from "../../utils";
import {
  getSourceToRevvFieldsMapping,
  getUnusedRevvFields,
  formatFieldsMapping,
  formatFormFields,
  // formatFieldData,
  formatCRMObjects,
  formatObjectSchema,
  getRevvToSourceMapping,
  getColumnDefs,
  updateSourceinFieldList,
  formatSinatoriesFields,
  formatMetaFields,
  getSourceFieldsMeta,
} from "./fieldsSettingMethod";

import { FIELDS } from "../../constants";

const { DATA_SOURCES, DATA_STUDIO_VIEW } = FIELDS;

// Destructuring
const { handleApiErrMsg } = GlobalUtils;

export const updateFormFieldsList =
  (fieldsList, signatories, metaGroups) => dispatch => {
    const combinedFiledList = [...fieldsList];
    const combinedSigneerList = [];
    let metaGroupsData = [];
    // Add signer details into the filed list if exists
    if (signatories && signatories.length > 0) {
      signatories.forEach((signer, index) => {
        if (Array.isArray(signer.tags) && signer.tags.length > 0)
          combinedSigneerList.push({
            id: signer.signer_identity_id,
            meta: { default: `${signer.first_name} ${signer.last_name}` },
            field_name: `signer-${index + 1}`,
            label: `Signer ${index + 1}`,
            type: "SIGNATURE",
            ...signer,
          });
      });
    }
    if (metaGroups && Array.isArray(metaGroups) && metaGroups.length > 0) {
      metaGroupsData = metaGroups;
    }

    const {
      fieldList,
      fieldDefs,
      fieldIDsList,
      fieldIDsWithInternalField,
      tableIdsList,
      tableIDsWithInternalField,
    } = formatFormFields(combinedFiledList);
    const { signerDefs, signerIDsList, signerIDsWithInternalField } =
      formatSinatoriesFields(combinedSigneerList);
    const {
      metaFieldsList,
      metaFieldDefs,
      metaFieldIDsList,
      metaFieldIDsWithInternalField,
    } = formatMetaFields(metaGroupsData[0]);
    dispatch({
      type: "FETCH_FIELDS_LIST",
      payload: {
        fields: !signatories
          ? [...fieldList, ...metaFieldsList]
          : [...fieldList, ...combinedSigneerList],
        fieldDefs,
        fieldIDsList,
        fieldIDsWithInternalField,
        signerDefs,
        signerIDsList,
        signerIDsWithInternalField,
        tableIdsList,
        tableIDsWithInternalField,
        metaFieldDefs,
        metaFieldIDsList,
        metaFieldIDsWithInternalField,
      },
    });
  };

export const updateTemplateFormFieldsList = () => dispatch => {
  const state = store.getState();
  const { template = {} } = state.TemplateStore;
  const { fields_used: fieldsUsed = [] } = template;
  const { document = {} } = state.DocumentStore;
  const { signatoriesV2: signatories = [] } = document;
  const { fieldsList } = state.FieldsSettingStore;
  const { metaGroups } = state.MetaFieldStore;
  let updatedFieldsUsed = fieldsUsed;
  let metaGroupFieldsLength = 0;
  if (
    Array.isArray(metaGroups) &&
    metaGroups.length > 0 &&
    Object.keys(metaGroups[0].meta.fields) &&
    Object.keys(metaGroups[0].meta.fields).length > 0
  ) {
    metaGroupFieldsLength = Object.keys(metaGroups[0].meta.fields).length;
  }
  if (
    Array.isArray(fieldsList) &&
    fieldsList.length ===
      fieldsUsed.length + signatories.length + metaGroupFieldsLength
  ) {
    updatedFieldsUsed = fieldsList;
  }
  let filteredFieldsUsed = updatedFieldsUsed.filter(
    field => field.type !== "IMAGE" && field.type !== "TABLE",
  );
  filteredFieldsUsed = filteredFieldsUsed.filter(field => {
    if (field.type === "CLAUSE") {
      const { meta: { subtype: subType } = {} } = field;
      if (subType === "free_text") {
        return true;
      }
      return false;
    }
    return true;
  });
  dispatch(updateFormFieldsList(filteredFieldsUsed, signatories, metaGroups));
};

export const fetchFormFields =
  (templateId, fieldsUsed, signatories) => dispatch => {
    dispatch({
      type: "START_FETCHING_FIELDS_LIST",
    });
    const state = store.getState();
    const { metaGroups } = state.MetaFieldStore;
    fetchAllFormFields(templateId)
      .then(response => {
        const fieldList = updateSourceinFieldList(
          fieldsUsed,
          response || [],
          signatories,
        );
        dispatch(updateFormFieldsList(fieldList, null, metaGroups));
      })
      .catch(error => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

export const updateDataSourceSelected = dataSourceSelected => dispatch => {
  dispatch({
    type: "UPDATE_DATASOURCE_SELECTED",
    payload: dataSourceSelected,
  });
};

export const getSourceObjectSchema = (dataSource, objectID) =>
  new Promise((resolve, reject) => {
    getSFObjectSchema(dataSource, objectID)
      .then(res => {
        const { CRMObject = [] } = res || {};
        resolve(CRMObject);
        return CRMObject;
      })
      .catch(err => {
        reject(err);
      });
  });

export const getSourceObjectsWithRelatedFields =
  (objectID, relatedFields, objSchema) => async dispatch => {
    const state = store.getState();
    const { dataSourceSelected } = state.FieldsSettingStore;
    const relatedObjs = Array.from(new Set(relatedFields));
    const relatedObjSchema = Array(relatedObjs.length);
    relatedObjs.forEach((objName, index) => {
      relatedObjSchema[index] = getSourceObjectSchema(
        dataSourceSelected,
        objName,
      );
    });

    return Promise.all([...relatedObjSchema]).then(response => {
      const fieldList = [];
      objSchema.forEach(field => {
        if (
          (field.field_type === "reference" ||
            field.field_type === "multi_reference") &&
          Array.isArray(field.reference_to) &&
          field.reference_to.length === 1
        ) {
          const refer_obj = field.reference_to[0];
          const objIndex = relatedObjs.findIndex(
            objName => objName === refer_obj,
          );
          fieldList.push({
            ...field,
            referObj: response[objIndex],
          });
        } else {
          fieldList.push({ ...field });
        }
      });

      const { filteredObj } = formatObjectSchema(fieldList);

      const payload = {
        objectID,
        schema: filteredObj,
      };

      dispatch({
        type: "FETCH_OBJECT_SCHEMA",
        payload,
      });
    });
  };

export const getSFObjectSchemaAction = objectID => dispatch =>
  new Promise((resolve, reject) => {
    const state = store.getState();
    const { dataSourceSelected } = state.FieldsSettingStore;
    getSFObjectSchema(dataSourceSelected, objectID)
      .then(res => {
        const { CRMObject = [] } = res || {};
        const payload = {
          objectID,
          schema: CRMObject,
        };
        let relatedFields = [];
        CRMObject.forEach(field => {
          if (
            (field.field_type === "reference" ||
              field.field_type === "multi_reference") &&
            Array.isArray(field.reference_to)
          ) {
            relatedFields = [...relatedFields, ...field.reference_to];
          }
        });
        if (relatedFields.length > 0) {
          dispatch(
            getSourceObjectsWithRelatedFields(
              objectID,
              relatedFields,
              CRMObject,
            ),
          );
        } else {
          dispatch({
            type: "FETCH_OBJECT_SCHEMA",
            payload,
          });
        }
        resolve(res);
      })
      .catch(err => {
        // window.location.pathname = "/fields/list";
        dispatch(updateDataSourceSelected(""));
        Toastr.showToastr({
          type: "failure",
          message: "Cannot show the data",
          timeout: 3000,
        });
        reject(err);
      });
  });

export const updateObjFieldMapping = (objName, mapping) => dispatch => {
  dispatch({
    type: "UPDATE_OBJECT_FIELD_MAPPING",
    payload: {
      objectName: objName,
      objectFieldsMapping: mapping,
    },
  });
};

export const resetCurrentSelectedObject = () => dispatch => {
  dispatch({
    type: "RESET_SELECTED_DS_OBJECT",
    payload: {},
  });
};

export const updateCurrentSelectedObject = objectName => dispatch => {
  const state = store.getState();
  const {
    fieldsMapping,
    revvFieldDefs,
    objectFieldsMapping,
    currentSelectedObject,
    revvFieldIDsWithInternalField,
    dataSourceSelected,
  } = state.FieldsSettingStore;
  // update old object mapping to fieldsMapping store
  if (currentSelectedObject && Array.isArray(objectFieldsMapping)) {
    const oldObjMapping = getRevvToSourceMapping(objectFieldsMapping);
    dispatch(updateObjFieldMapping(currentSelectedObject, oldObjMapping));
  }

  // check if object fields are available or not
  if (dataSourceSelected !== "csv")
    dispatch(getSFObjectSchemaAction(objectName));
  const currObjFieldsMapping =
    fieldsMapping && objectName in fieldsMapping
      ? getSourceToRevvFieldsMapping(fieldsMapping[objectName], revvFieldDefs)
      : [];
  const unusedRevvFieldIDs = getUnusedRevvFields(
    revvFieldIDsWithInternalField,
    currObjFieldsMapping,
  );
  dispatch({
    type: "UPDATE_SELECTED_DS_OBJECT",
    payload: {
      objectName,
      objectFieldsMapping: currObjFieldsMapping,
      unusedRevvFieldIDs,
    },
  });
};

// can be source field name or form field id
export const dragDataPlayfieldAction =
  (type, fieldID, subField = "") =>
  dispatch => {
    dispatch({
      type: "DRAG_DATA_PLAYFIELD",
      payload: {
        type,
        fieldID,
        internalField: subField,
      },
    });
  };

export const updateSyncDataSourceFlags =
  (dataSource, objectName, startDate, endDate, templateID, status) =>
  dispatch =>
    dispatch({
      type: "START_DATASOURCE_SYNC",
      payload: {
        dataSource,
        objectName,
        startDate,
        endDate,
        templateID,
        status,
        loadMore: true,
      },
    });

export const nukeSyncDataSourceFlags = () => dispatch =>
  dispatch({ type: "NUKE_DATASOURCE_SYNC", payload: "" });

export const dataSourceSyncCompleted = () => dispatch => {
  dispatch({
    type: "DATASOURCE_SYNC_DONE",
  });
};

export const toggleLoadMoreFlag = () => dispatch => {
  dispatch({
    type: "TOGGLE_LOADMORE_FLAG",
  });
};

export const toggleFieldRowSelection = rowIndex => dispatch => {
  dispatch({
    type: "TOGGLE_FIELD_ROW_SELECTION",
    payload: rowIndex,
  });
};

export const nukeAllRowsSelected = () => dispatch => {
  dispatch({
    type: "NUKE_ALL_ROWS_SELECTED",
  });
};

export const updateDataPlayFieldData = (fieldData, isLoadMore) => dispatch => {
  const state = store.getState();
  const { fieldsList, objectFieldsMapping, tableIdsList } =
    state.FieldsSettingStore;
  const {
    response: transformedData,
    start_datetime: startDate,
    end_datetime: endTime,
    page: pageInfo,
  } = fieldData;

  const primaryKeyField = objectFieldsMapping.find(
    mapping => mapping.isPrimaryKey,
  );

  const columnDefs = getColumnDefs(
    transformedData,
    fieldsList,
    primaryKeyField ? primaryKeyField.revvFieldID : null,
    tableIdsList,
  );
  if (Array.isArray(columnDefs) && columnDefs.length > 0) {
    columnDefs[0].headerCheckboxSelection = "true";
    columnDefs[0].headerCheckboxSelectionFilteredOnly = "true";
  }
  const selectedRows = Array(transformedData.length);
  selectedRows.fill(false);
  dispatch({
    type: "UPDATE_PLAYFIELD_DATA",
    payload: {
      filterMeta: {
        startDate,
        endTime,
        pageInfo,
      },
      transformedData,
      columnDefs,
      selectedRows,
      isLoadMore,
    },
  });
};

export const updateDataStdioView = view => dispatch => {
  dispatch({
    type: "UPDATE_DATASTUDIO_VIEW",
    payload: view,
  });
};

export const updateDataStudioMappedView = view => dispatch => {
  dispatch({
    type: "UPDATE_DATASTUDIO_MAPPED_VIEW",
    payload: view,
  });
};
export const fetchTransformedData =
  (
    dataSource,
    objectName,
    startDate,
    endDate,
    templateID,
    pageNum,
    isLoadMore,
  ) =>
  dispatch => {
    const state = store.getState();
    const {
      currentSelectedObject,
      dataSourceSelected,
      sourceObjSchema,
      fieldsList,
      csvData,
    } = state.FieldsSettingStore;
    const source = DATA_SOURCES.find(ds => ds.name === dataSourceSelected);
    const perPageCount = 100;
    let syncDetails = {};
    if (dataSourceSelected === "csv") {
      syncDetails = {
        source: source.urlRef,
        object_name: objectName,
        start_datetime: "",
        end_datetime: "",
        template_id: templateID,
        page: {},
        revv_field_meta: fieldsList,
        source_field_meta: csvData.fields,
        data_payload: csvData.fieldsData,
      };
    } else {
      syncDetails = {
        source: source.urlRef,
        object_name: currentSelectedObject,
        start_datetime: startDate,
        end_datetime: endDate,
        template_id: templateID,
        page: {
          nextpage: pageNum,
          after: `${(pageNum - 1) * perPageCount}`,
        },
        revv_field_meta: fieldsList,
        source_field_meta: getSourceFieldsMeta(
          sourceObjSchema[currentSelectedObject].All,
        ),
      };
    }
    startDataSourceSync(syncDetails)
      .then(res => {
        const { DSSyncedData } = res;
        if (
          DSSyncedData.response &&
          Array.isArray(DSSyncedData.response) &&
          DSSyncedData.response.length > 0
        ) {
          dispatch(updateDataPlayFieldData(DSSyncedData, isLoadMore));
        } else if (
          DSSyncedData.response === null ||
          (Array.isArray(DSSyncedData.response) &&
            DSSyncedData.response.length === 0)
        ) {
          dispatch(toggleLoadMoreFlag());
          dispatch(dataSourceSyncCompleted());
        } else {
          Toastr.showToastr({
            type: "failure",
            message: "Error in syncing data",
            timeout: 3000,
          });
          dispatch(updateDataStdioView(DATA_STUDIO_VIEW.CONFIG_VIEW));
        }
      })
      .catch(error => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        dispatch(updateDataStdioView(DATA_STUDIO_VIEW.CONFIG_VIEW));
      });
  };

export const startSyncingDataSource =
  (dataSource, objectName, startDate, endDate, templateID, pageNum = 1) =>
  dispatch => {
    const startDateTime = startDate ? `${startDate.format("YYYY-MM-DD")}` : "";
    const endDateTime = endDate ? `${endDate.format("YYYY-MM-DD")}` : "";
    dispatch(
      updateSyncDataSourceFlags(
        dataSource,
        objectName,
        startDateTime,
        endDateTime,
        templateID,
        "STARTED",
        pageNum,
      ),
    );
    dispatch(
      fetchTransformedData(
        dataSource,
        objectName,
        startDateTime,
        endDateTime,
        templateID,
        pageNum,
      ),
    );
  };

export const updateCRMConfig = dsName => dispatch => {
  const dataSource = DATA_SOURCES.find(source => source.name === dsName);
  dispatch({
    type: "UPDATE_DATA_SOURCE_AUTH_FLAG",
    payload: {
      dataSource: dataSource ? dataSource.urlRef : null,
    },
  });
};

export const initFieldsMappingData = datasource => async dispatch => {
  try {
    const state = store.getState();
    const { template: { id: templateID } = {} } = state.TemplateStore;
    const { currentSelectedObject } = state.FieldsSettingStore;
    const fieldsMapping = await fetchFieldMapping(templateID, datasource);
    if (datasource === "csv") {
      return Promise.all([fieldsMapping]).then(response => {
        const mappingData = response[0];
        const objectFormattedMapping = formatFieldsMapping(
          mappingData.DSObjectMapping,
        );
        dispatch({
          type: "UPDATE_FIELD_MAPPING",
          payload: objectFormattedMapping,
        });
        dispatch(updateCurrentSelectedObject("CSV"));
      });
    }
    const dataSourceObjects = await fetchDSObjects(datasource);
    return Promise.all([fieldsMapping, dataSourceObjects]).then(response => {
      const mappingData = response[0];
      const sourceObjects = response[1];
      const objectFormattedMapping = formatFieldsMapping(
        mappingData.DSObjectMapping,
      );
      const { CRMObjects = [] } = sourceObjects;
      const dsObjects = formatCRMObjects(CRMObjects);
      dispatch({
        type: "FETCH_DS_OBJECTS",
        payload: {
          dsObjects,
        },
      });
      dispatch({
        type: "NUKE_CSV_DATA",
      });
      dispatch({
        type: "UPDATE_FIELD_MAPPING",
        payload: objectFormattedMapping,
      });
      if (Array.isArray(dsObjects) && dsObjects.length > 0) {
        let setDefCurrObject = "Opportunity";
        const checkObj = dsObjects.some(dsObject => {
          if (dsObject.name === setDefCurrObject) {
            return true;
          }
          return false;
        });
        if (!checkObj) {
          setDefCurrObject = dsObjects[0].name;
        }
        dispatch(
          updateCurrentSelectedObject(
            currentSelectedObject !== null
              ? currentSelectedObject
              : setDefCurrObject,
          ),
        );
      }
      return {
        mappingData,
        sourceObjects,
      };
    });
  } catch (error) {
    // window.location.pathname = "/fields/list";
    dispatch(updateCRMConfig(datasource));
    Toastr.showToastr({
      type: "failure",
      message: handleApiErrMsg(error),
      timeout: 3000,
    });
    throw error;
  }
};

export const fetchAllFieldsMapping = () => dispatch => {
  fetchFieldMapping()
    .then(response => {
      const objectFormattedMapping = formatFieldsMapping(
        response.DSObjectMapping,
      );
      dispatch({
        type: "UPDATE_FIELD_MAPPING",
        payload: objectFormattedMapping,
      });
    })
    .catch(error => {
      // window.location.pathname = "/fields/list";
      dispatch(updateDataSourceSelected(""));
      Toastr.showToastr({
        type: "failure",
        message: handleApiErrMsg(error),
        timeout: 3000,
      });
    });
};

export const createTriggerAction = createTriggerPayload => dispatch =>
  new Promise((resolve, reject) => {
    createTriggerService(createTriggerPayload)
      .then(res => {
        dispatch({
          type: "CREATE_TRIGGER_DETAILS",
          payload: res.Trigger_Details,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const updateTriggerAction =
  (updateTriggerPayload, triggerId) => dispatch =>
    new Promise((resolve, reject) => {
      updateTriggerService(updateTriggerPayload, triggerId)
        .then(res => {
          dispatch({
            type: "UPDATE_TRIGGER_DETAILS",
            payload: res.Trigger_Details,
          });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

export const getTriggerDetailsAction = templateId => dispatch =>
  new Promise((resolve, reject) => {
    getTriggerDetailsService(templateId)
      .then(res => {
        dispatch({
          type: "FETCH_TRIGGER_DETAILS",
          payload: res.Trigger_Details,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });

export const getTriggerPackageAction = () => dispatch =>
  new Promise((resolve, reject) => {
    getTriggerPackageService()
      .then(res => {
        dispatch({
          type: "FETCH_TRIGGER_PACKAGE_URL",
          payload: res.package_url,
        });
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
export const updateFieldMappingSchema = (mappingID, schema) => dispatch => {
  dispatch({
    type: "UPDATE_FIELD_SCHEMA",
    payload: {
      schema,
      mappingID,
    },
  });
};

export const updatePrimaryKeyinFieldsMapping =
  (formFieldID, templateId, removePrimaryKey) => dispatch => {
    // get object mapping schema
    const state = store.getState();

    const { objectFieldsMapping, currentSelectedObject, dataSourceSelected } =
      state.FieldsSettingStore;
    const updatedFieldsMapping = [];
    let id = null;
    const fieldMapping = [];
    const internalFields = [];
    let removedPKFormFieldID = null;
    objectFieldsMapping.forEach(mapping => {
      const {
        id: currMappingID,
        isPrimaryKey,
        revvFieldID: currFieldID,
        revvSubField: currSubField,
      } = mapping;
      if (currFieldID === formFieldID) {
        if (
          (removePrimaryKey && isPrimaryKey) ||
          (!removePrimaryKey && !isPrimaryKey)
        ) {
          updatedFieldsMapping.push({
            ...mapping,
            isPrimaryKey: !removePrimaryKey,
          });
        }
      } else if (!removePrimaryKey && isPrimaryKey) {
        removedPKFormFieldID = currFieldID;
        updatedFieldsMapping.push({
          ...mapping,
          isPrimaryKey: false,
        });
        fieldMapping.push({
          ...mapping.mapping,
          internal_field: currSubField || null,
        });

        if (currSubField) internalFields.push(currSubField);

        // update field id
        if (currMappingID) id = currMappingID;
      }
    });

    // update the removed primary key in backend
    if (id && fieldMapping.length > 0) {
      const dataSource = DATA_SOURCES.find(
        ds => ds.name === dataSourceSelected,
      );
      const mappingSchema = {
        id,
        object_name: currentSelectedObject,
        source: dataSource.urlRef,
        schema: {
          meta: {
            internal_fields: internalFields,
          },
          mapping: fieldMapping,
          source_fields: [],
        },
        template_id: templateId,
        form_field_id: null,
        signer_id: null,
        meta_group_id: null,
      };

      if (removedPKFormFieldID.startsWith("DFLD")) {
        mappingSchema.form_field_id = removedPKFormFieldID;
      } else if (removedPKFormFieldID.startsWith("METAG")) {
        mappingSchema.meta_group_id = removedPKFormFieldID;
      } else {
        mappingSchema.signer_id = removedPKFormFieldID;
      }

      saveFieldMapping(mappingSchema).then(() => {
        dispatch({
          type: "UPDATE_MULTIPLE_MAPPING",
          payload: { updatedFieldsMapping },
        });
      });
    } else {
      dispatch({
        type: "UPDATE_MULTIPLE_MAPPING",
        payload: { updatedFieldsMapping },
      });
    }
  };

export const removeFieldMappingSchema =
  (revvFieldID, revvSubField, mappingID) => dispatch => {
    dispatch({
      type: "REMOVE_FIELD_MAPPING",
      payload: {
        revvFieldID,
        revvSubField,
        mappingID,
      },
    });
  };

export const updateFieldMappingAction =
  (mappingID, schema, templateId) => dispatch => {
    // get object mapping schema
    const state = store.getState();

    const { objectFieldsMapping, currentSelectedObject, dataSourceSelected } =
      state.FieldsSettingStore;
    // destore all the objects
    const {
      revvFieldID,
      mapping: { source_fields: currSRCFields = [] } = {},
      isPrimaryKey,
    } = schema;

    const oldSchema = objectFieldsMapping.find(
      mapp => mapp.mappingID === mappingID,
    );

    const {
      revvFieldID: oldrevvFieldID = null,
      mapping: { source_fields: oldSRCFields = [] } = {},
      isPrimaryKey: wasParimaryKey,
    } = oldSchema || {};

    // get mapping id if available
    let { id } = schema;

    if (
      (!revvFieldID && oldrevvFieldID) ||
      (currSRCFields.length === 0 && oldSRCFields.length > 0)
    ) {
      schema.id = null;
    }
    // update redux for current mapping
    dispatch(updateFieldMappingSchema(mappingID, schema));

    const formFieldID = revvFieldID || oldrevvFieldID;

    // now check for save and delete
    if (formFieldID) {
      const currFieldMapping = objectFieldsMapping.filter(
        mapping =>
          mapping.revvFieldID === formFieldID ||
          mapping.mappingID === mappingID,
      );

      // remove other primary key
      if (
        (isPrimaryKey && !wasParimaryKey) ||
        (!isPrimaryKey && wasParimaryKey)
      ) {
        dispatch(
          updatePrimaryKeyinFieldsMapping(
            formFieldID,
            templateId,
            !isPrimaryKey && wasParimaryKey,
          ),
        );
      }
      const fieldMapping = [];
      const internalFields = [];

      if (Array.isArray(currFieldMapping) && currFieldMapping.length > 0) {
        currFieldMapping.forEach(mapping => {
          // update mapping list
          const currentMapping =
            mappingID === mapping.mappingID ? schema : mapping;

          // update source fields list
          const { revvSubField: currSubField, revvFieldID: currRevvFieldID } =
            currentMapping;

          const currMappingID = schema.id || mapping.id;

          const { mapping: { source_fields: sourceFields = [] } = {} } =
            currentMapping;

          if (currRevvFieldID && sourceFields.length !== 0) {
            fieldMapping.push({
              ...currentMapping.mapping,
              internal_field: currSubField || null,
            });
            // update internal fields
            if (currSubField) internalFields.push(currSubField);
          }

          // update field id
          if (currMappingID) id = currMappingID;
        });
        // For new internal field
        if (
          schema.revvSubField &&
          !internalFields.includes(schema.revvSubField)
        ) {
          const currentMapping = schema;

          const currMappingID = null;

          // update source fields list
          const { revvSubField: currSubField, revvFieldID: currRevvFieldID } =
            currentMapping;

          const { mapping: { source_fields: sourceFields = [] } = {} } =
            currentMapping;

          if (currRevvFieldID && sourceFields.length !== 0) {
            fieldMapping.push({
              ...currentMapping.mapping,
              internal_field: currSubField || null,
            });
            // update internal fields
            if (currSubField) internalFields.push(currSubField);
          }

          // update field id
          if (currMappingID) id = currMappingID;
        }
      } else {
        // update mapping list
        const currentMapping = schema;

        const currMappingID = null;

        // update source fields list
        const { revvSubField: currSubField, revvFieldID: currRevvFieldID } =
          currentMapping;

        const { mapping: { source_fields: sourceFields = [] } = {} } =
          currentMapping;

        if (currRevvFieldID && sourceFields.length !== 0) {
          fieldMapping.push({
            ...currentMapping.mapping,
            internal_field: currSubField || null,
          });
          // update internal fields
          if (currSubField) internalFields.push(currSubField);
        }

        // update field id
        if (currMappingID) id = currMappingID;
      }

      if (id && currFieldMapping.length > fieldMapping.length) {
        const { revvSubField } = schema;
        deleteFieldMapping(id).then(() => {
          dispatch(
            removeFieldMappingSchema(revvFieldID, revvSubField, mappingID),
          );
        });
      } else if (fieldMapping.length > 0) {
        const dataSource = DATA_SOURCES.find(
          ds => ds.name === dataSourceSelected,
        );
        const mappingSchema = {
          object_name: currentSelectedObject,
          source: dataSource.urlRef,
          schema: {
            meta: {
              internal_fields: internalFields,
              is_primary_key: isPrimaryKey,
            },
            mapping: fieldMapping,
            source_fields: [],
          },
          template_id: templateId,
          form_field_id: null,
          signer_id: null,
          meta_group_id: null,
        };

        if (revvFieldID && revvFieldID.startsWith("DFLD")) {
          mappingSchema.form_field_id = revvFieldID;
        } else if (revvFieldID && revvFieldID.startsWith("METAG")) {
          mappingSchema.meta_group_id = revvFieldID;
        } else if (revvFieldID) {
          mappingSchema.signer_id = revvFieldID;
        }

        if (id) mappingSchema.id = id;
        saveFieldMapping(mappingSchema).then(response => {
          if (!schema.id && revvFieldID) {
            // update redux for current mapping
            dispatch(
              updateFieldMappingSchema(mappingID, {
                ...schema,
                id: response.DSObjectMapping.id,
              }),
            );
          }
        });
      }
    }
  };

export const removeFieldMappingAction = (mapping, templateId) => dispatch => {
  const state = store.getState();
  const { mappingID, revvFieldID, revvSubField, id } = mapping;

  if (revvFieldID && id) {
    const { objectFieldsMapping, dataSourceSelected, currentSelectedObject } =
      state.FieldsSettingStore;

    const sameRevvFieldIDMapping = revvFieldID
      ? objectFieldsMapping.filter(
          f => f.revvFieldID === revvFieldID && f.revvSubField !== revvSubField,
        )
      : [];

    if (sameRevvFieldIDMapping.length === 0) {
      deleteFieldMapping(id).then(() => {
        dispatch(
          removeFieldMappingSchema(revvFieldID, revvSubField, mappingID),
        );
      });
    } else {
      const fieldMapping = [];
      const internalFields = [];

      sameRevvFieldIDMapping.forEach(schema => {
        // update source fields list
        const { revvSubField: currSubField } = schema;

        // update mapping list
        fieldMapping.push({
          ...schema.mapping,
          internal_field: currSubField || null,
        });

        // update internal fields
        if (currSubField) internalFields.push(currSubField);
      });

      const dataSource = DATA_SOURCES.find(
        ds => ds.name === dataSourceSelected,
      );

      const mappingSchema = {
        object_name: currentSelectedObject,
        source: dataSource.urlRef,
        schema: {
          meta: {
            internal_fields: internalFields,
          },
          mapping: fieldMapping,
          source_fields: [],
        },
        template_id: templateId,
        form_field_id: null,
        signer_id: null,
        meta_group_id: null,
      };

      if (revvFieldID.startsWith("DFLD")) {
        mappingSchema.form_field_id = revvFieldID;
      } else if (revvFieldID && revvFieldID.startsWith("METAG")) {
        mappingSchema.meta_group_id = revvFieldID;
      } else {
        mappingSchema.signer_id = revvFieldID;
      }

      if (id) mappingSchema.id = id;

      saveFieldMapping(mappingSchema).then(() => {
        dispatch(
          removeFieldMappingSchema(revvFieldID, revvSubField, mappingID),
        );
      });
    }
  } else {
    dispatch(removeFieldMappingSchema(revvFieldID, revvSubField, mappingID));
  }
};

export const nukeFieldSettingDetails = () => dispatch => {
  dispatch({
    type: "NUKE_FIELD_SETTING",
  });
};

export const setKeyForCard = id => dispatch => {
  dispatch({
    type: "SET_KEY_FOR_CARD",
    payload: {
      id,
    },
  });
};

export const setFlagForAgrgrid = data => dispatch => {
  dispatch({
    type: "SET_KEY_FOR_AGGRID",
    payload: {
      data,
    },
  });
};

export const setCSVData = data => dispatch => {
  dispatch({
    type: "SET_CSV_DATA",
    payload: {
      data,
    },
  });
};

export const nukeCSVData = () => dispatch => {
  dispatch({
    type: "NUKE_CSV_DATA",
  });
};

export const updateEmptyMappings = emptyMappingsData => dispatch => {
  dispatch({
    type: "EMPTY_MAPPINGS",
    payload: {
      emptyMappings: emptyMappingsData,
    },
  });
};
